// Coordena o único "slot" de banner no rodapé (InstallBanner, UpdatePrompt)
// para os dois nunca aparecerem empilhados/sobrepostos ao mesmo tempo. Cada
// banner reivindica o slot por uma `key` com uma `priority`; apenas o de maior
// prioridade ativo é dono do slot e renderiza. UpdatePrompt tem prioridade
// sobre o InstallBanner (atualização é mais relevante que "instalar app").
//
// Sem store externo: Map + listeners. Mesma linguagem do activityGuard.

type Listener = () => void;

const claims = new Map<string, number>();
const listeners = new Set<Listener>();

function emit(): void {
  listeners.forEach((l) => l());
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function claimSlot(key: string, priority: number): void {
  if (claims.get(key) !== priority) {
    claims.set(key, priority);
    emit();
  }
}

export function releaseSlot(key: string): void {
  if (claims.delete(key)) emit();
}

// Só é dono quem tem a maior prioridade entre os claims ativos. Prioridades
// distintas por banner evitam empate.
export function ownsSlot(key: string): boolean {
  if (!claims.has(key)) return false;
  let maxKey: string | null = null;
  let maxPriority = -Infinity;
  for (const [k, p] of claims) {
    if (p > maxPriority) {
      maxPriority = p;
      maxKey = k;
    }
  }
  return maxKey === key;
}
